<div class="wrapper">
  <div class="upper-content">
    <div class="first-column">
      <app-info-oc-or-nfe label="Nível" [value]="level.name"></app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="Ordem" [value]="level.order"></app-info-oc-or-nfe>

    </div>
    <div class="second-column">
      <app-info-oc-or-nfe label="Começo" [value]="level.start"></app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="Referência" [value]="level.reference"></app-info-oc-or-nfe>
      <app-info-oc-or-nfe label="Fim" [value]="level.end"></app-info-oc-or-nfe>
    </div>
    <div class="forms-column">
      <mat-form-field>
        <mat-label>Tipo</mat-label>
        <input type="text" aria-label="Tipo" matInput [formControl]="typeFormControl" [matAutocomplete]="typeAutocomplete">
        <mat-autocomplete autoActiveFirstOption #typeAutocomplete="matAutocomplete">
          <mat-option *ngFor="let option of filteredTypes | async" [value]="option">
            {{option}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Setor</mat-label>
        <input type="text" aria-label="Setor" matInput [formControl]="groupFormControl" [matAutocomplete]="groupAutocomplete">
        <mat-autocomplete autoActiveFirstOption #groupAutocomplete="matAutocomplete" [displayWith]="displayGroupNameFn">
          <mat-optgroup *ngFor="let group of groundOptions | async" [label]="group.type">
            <mat-option *ngFor="let option of group.options" [value]="option">
              {{option.name}}
            </mat-option>
          </mat-optgroup>
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </div>
  <section class="buttons-container">
    <button mat-stroked-button class="gray-1" (click)="close()">
      Cancelar
    </button>
    <button mat-raised-button class="primary-1" (click)="applyChanges()">
      Salvar
    </button>
  </section>
</div>